import { render, staticRenderFns } from "./ques33.vue?vue&type=template&id=2dd68d45&scoped=true"
import script from "./ques33.vue?vue&type=script&lang=js"
export * from "./ques33.vue?vue&type=script&lang=js"
import style0 from "./ques33.vue?vue&type=style&index=0&id=2dd68d45&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd68d45",
  null
  
)

export default component.exports